export function useExportLoading() {
	const exportLoadingCount = useState<number>('exportLoadingCount', () => 0);
	const isExportDownloading = computed(() => exportLoadingCount.value > 0);

	const startExportLoading = () => {
		exportLoadingCount.value += 1;
	};

	const endExportLoading = () => {
		exportLoadingCount.value = Math.max(0, exportLoadingCount.value - 1);
	};

	return {
		isExportDownloading,
		startExportLoading,
		endExportLoading,
	};
}
